module.exports = __webpack_public_path__ + "static/media/instagram.bdce3a1a.svg";